import { ProductScreenshot } from 'components/ProductScreenshot';
import { ProductVideo } from 'components/ProductVideo';
import surveyInsightsLight from "../../../../contents/images/docs/surveys/survey-insights-light-mode.mp4";
import surveyInsightsDark from "../../../../contents/images/docs/surveys/survey-insights-dark-mode.mp4";
import surveyResultsLight from "../../../../contents/images/docs/surveys/survey-results-sample-light-mode.png";
import surveyResultsDark from "../../../../contents/images/docs/surveys/survey-results-sample-dark-mode.png";
import * as React from 'react';
export default {
  ProductScreenshot,
  ProductVideo,
  surveyInsightsLight,
  surveyInsightsDark,
  surveyResultsLight,
  surveyResultsDark,
  React
};